import React from 'react';

interface LinkedInRendererProps {
  data: any;
}

const LinkedInRenderer: React.FC<LinkedInRendererProps> = ({ data }) => {
  if (!data.posts) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
        <div className="text-sm text-gray-500">No LinkedIn posts available</div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
      {data.posts?.length > 1 && (
        <div className="text-sm text-gray-600">
          <strong>LinkedIn Posts:</strong> {data.posts.length} posts
        </div>
      )}

      {data.posts?.map((post: any, index: number) => (
        <div key={index} className="border-l-2 border-blue-200 pl-3 space-y-3">
          {data.posts?.length > 1 && (
            <div className="text-xs text-gray-500 mb-1">
              Post {index + 1} of {data.posts.length}
            </div>
          )}

          <div className="text-gray-800 whitespace-pre-wrap text-sm">{post.content}</div>

          <div className="flex flex-wrap gap-2 mt-2">
            {post.hashtags?.map((tag: string, i: number) => (
              <span key={i} className="text-blue-600 text-sm bg-blue-50 px-2 py-1 rounded">
                {tag}
              </span>
            ))}
          </div>

          <div className="text-sm text-gray-500 mt-2">
            <strong>CTA:</strong> {post.call_to_action}
          </div>

          <div className="text-sm text-gray-500">
            <strong>Tone:</strong> {post.tone}
          </div>

          {post.engagement_hooks && post.engagement_hooks.length > 0 && (
            <div>
              <div className="text-sm font-medium text-gray-700 mb-1">Engagement Hooks:</div>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                {post.engagement_hooks.map((hook: string, i: number) => (
                  <li key={i}>{hook}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LinkedInRenderer;
